export default __webpack_public_path__ + "static/media/youtube.7e2362ca.svg";